export default __webpack_public_path__ + "static/media/rt-team-4-paul.98b332e4.png";